import { refId } from "@suse-o11y/ref-id";
import { useMonitor } from "@suse-o11y/signal";
import type { FormList } from "@suse-o11y/signal/form";
import React from "react";

import { Alert } from "~/components/alert";
import { For } from "~/components/for";
import { splice } from "~/tools/splice";

import { FormState } from "./_link/form-state";
import { Link } from "./_link";

export interface LinksProps {
	links: FormList<FormState>;
}

export const Links: React.FC<LinksProps> = ({ links }) => {
	const monitor = useMonitor();

	return (
		<div>
			<For
				className="space-y-4"
				each={links.getElements(monitor)}
				el="ol"
				empty={
					<Alert variant="info">
						No links are configured for this widget yet. You can add relative (internal) or absolute (external) links to
						the widget.
					</Alert>
				}
			>
				{(link, index) => (
					<li key={refId(link)}>
						<Link
							link={link}
							name={index === 0 ? "Primary link" : `Additional link #${index}`}
							onDelete={() => {
								links.setInput(splice(index, 1, []));
							}}
						/>
					</li>
				)}
			</For>

			<footer className="mt-6 flex flex-row gap-3">
				<button
					className="button button-secondary uppercase"
					onClick={() => {
						links.setInitial((current) => [...current, FormState.initial]);
					}}
					type="button"
				>
					Add link
				</button>

				{links.isDirty(monitor) && (
					<button className="button button-tertiary uppercase" onClick={() => links.reset()} type="button">
						Reset links
					</button>
				)}
			</footer>
		</div>
	);
};
